module.exports = __webpack_public_path__ + "static/media/g2h.89857172.gif";